"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "celsiusToFahrenheit", {
  enumerable: true,
  get: function get() {
    return _temperature.celsiusToFahrenheit;
  }
});
Object.defineProperty(exports, "checkStatusObject", {
  enumerable: true,
  get: function get() {
    return _status.checkStatusObject;
  }
});
Object.defineProperty(exports, "dataURItoBlob", {
  enumerable: true,
  get: function get() {
    return _images.dataURItoBlob;
  }
});
Object.defineProperty(exports, "debounce", {
  enumerable: true,
  get: function get() {
    return _debounce.debounce;
  }
});
Object.defineProperty(exports, "deltaCelsiusToFahrenheit", {
  enumerable: true,
  get: function get() {
    return _temperature.deltaCelsiusToFahrenheit;
  }
});
Object.defineProperty(exports, "fahrenheitToCelsius", {
  enumerable: true,
  get: function get() {
    return _temperature.fahrenheitToCelsius;
  }
});
Object.defineProperty(exports, "flatMarkerArray", {
  enumerable: true,
  get: function get() {
    return _markers.flatMarkerArray;
  }
});
Object.defineProperty(exports, "getAssetsFromURL", {
  enumerable: true,
  get: function get() {
    return _images.getAssetsFromURL;
  }
});
Object.defineProperty(exports, "getBasicPresentationFlags", {
  enumerable: true,
  get: function get() {
    return _unpackImageInfo.getBasicPresentationFlags;
  }
});
Object.defineProperty(exports, "getCalProps", {
  enumerable: true,
  get: function get() {
    return _unpackImageInfo.getCalProps;
  }
});
Object.defineProperty(exports, "getCanvasBlob", {
  enumerable: true,
  get: function get() {
    return _images.getCanvasBlob;
  }
});
Object.defineProperty(exports, "getDisplayDelta", {
  enumerable: true,
  get: function get() {
    return _temperature.getDisplayDelta;
  }
});
Object.defineProperty(exports, "getDisplayTemperature", {
  enumerable: true,
  get: function get() {
    return _temperature.getDisplayTemperature;
  }
});
Object.defineProperty(exports, "getDisplayUnit", {
  enumerable: true,
  get: function get() {
    return _temperature.getDisplayUnit;
  }
});
Object.defineProperty(exports, "getIRPaletteSetup", {
  enumerable: true,
  get: function get() {
    return _unpackImageInfo.getIRPaletteSetup;
  }
});
Object.defineProperty(exports, "getIRVIEWERProps", {
  enumerable: true,
  get: function get() {
    return _unpackImageInfo.getIRVIEWERProps;
  }
});
Object.defineProperty(exports, "getMarkerById", {
  enumerable: true,
  get: function get() {
    return _markers.getMarkerById;
  }
});
Object.defineProperty(exports, "getMarkerProps", {
  enumerable: true,
  get: function get() {
    return _unpackImageInfo.getMarkerProps;
  }
});
Object.defineProperty(exports, "getMetadataHead", {
  enumerable: true,
  get: function get() {
    return _unpackImageInfo.getMetadataHead;
  }
});
Object.defineProperty(exports, "getObjectAsJSONFile", {
  enumerable: true,
  get: function get() {
    return _images.getObjectAsJSONFile;
  }
});
Object.defineProperty(exports, "getReasonIndex", {
  enumerable: true,
  get: function get() {
    return _status.getReasonIndex;
  }
});
Object.defineProperty(exports, "getStatus", {
  enumerable: true,
  get: function get() {
    return _status.getStatus;
  }
});
Object.defineProperty(exports, "getStatusCode", {
  enumerable: true,
  get: function get() {
    return _status.getStatusCode;
  }
});
Object.defineProperty(exports, "getStatusCodes", {
  enumerable: true,
  get: function get() {
    return _status.getStatusCodes;
  }
});
Object.defineProperty(exports, "getStatusDescription", {
  enumerable: true,
  get: function get() {
    return _status.getStatusDescription;
  }
});
Object.defineProperty(exports, "getStatusIndex", {
  enumerable: true,
  get: function get() {
    return _status.getStatusIndex;
  }
});
Object.defineProperty(exports, "getVisibleStandardMarkers", {
  enumerable: true,
  get: function get() {
    return _markers.getVisibleStandardMarkers;
  }
});
exports.hooks = void 0;
Object.defineProperty(exports, "unpackImageInfo", {
  enumerable: true,
  get: function get() {
    return _unpackImageInfo.default;
  }
});
var _markers = require("./markers");
var _notes = _interopRequireDefault(require("./notes"));
var _debounce = require("./debounce");
var _unpackImageInfo = _interopRequireWildcard(require("./unpackImageInfo"));
var _status = require("./status");
var _temperature = require("./temperature");
var _images = require("./images");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// misc

// utilities: imageInfo

// utilities: markers

// utilities: status

// utilities: temperature

// utilities: handle images

// hooks
var hooks = exports.hooks = {
  useMarkers: _markers.useMarkers,
  useNotes: _notes.default
};